module.exports = __webpack_public_path__ + "img/logo.0dac996.png";